export default __webpack_public_path__ + "static/ak-cached/24h/media/tv-box.ade06d5e.png";